import { Component } from '@angular/core';
import { ParticipantFooterComponent } from '../participant-footer/participant-footer.component';
import { ParticipantHeaderComponent } from '../participant-header/participant-header.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-participant-layout',
  templateUrl: './participant-layout.component.html',
  styleUrls: ['./participant-layout.component.css'],
  standalone: true,
  imports: [ParticipantFooterComponent,ParticipantHeaderComponent,CommonModule,RouterModule]
})
export class ParticipantLayoutComponent { }
